<ng-container *ngIf="course.syllabus">
  <mat-tab-group>
    <mat-tab *ngFor="let recommender of course.syllabus.recommenders; index as i" [label]=recommender.name>
      <form class="w-100 title-form" (ngSubmit)="onSubmit(course.syllabus)" (ngModelChange)="onSubmit(course.syllabus)">
        <div class="p-3">
          <div class="pt-2">
            <mat-form-field class="w-100">
              <input matInput class="text-left font-size-base" placeholder="이곳에 이름을 입력해주세요." [(ngModel)]="recommender.name" name="name"/>
            </mat-form-field>
            <mat-form-field class="w-100">
              <input matInput class="text-left font-size-base" placeholder="이곳에 직업을 입력해주세요." [(ngModel)]="recommender.pos" name="pos"/>
            </mat-form-field>
          </div>
          <mat-form-field class="w-100">
            <textarea rows="5" placeholder="이곳에 내용을 입력해주세요." matInput [(ngModel)]="recommender.comment" name="comment"></textarea>
          </mat-form-field>
        </div>
        <button mat-raised-button color="accent" type="submit">저장</button>
        <button mat-button (click)="removeRecommenderTab(i)">삭제</button>
      </form>
    </mat-tab>
  </mat-tab-group>

  <button mat-fab class="float-right" color="accent" (click)="addRecommender()">
    <mat-icon>add</mat-icon>
  </button>
</ng-container>



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/syllabuses/syllabus-recommenders-edit/syllabus-recommenders-edit.component.html